import {CloseOutlined as AntdCloseOutlined} from '@ant-design/icons';

export default function CloseOutlined(props) {
  return <AntdCloseOutlined {...props} />;
}
